export default {
  urlContentPage: '/umbraco/api/generalcontentsearchapi/itemsbylistingpageid',
  ListingPageId: null,
  urlContentSearch: '/umbraco/api/generalcontentsearchapi/items',  
  urlSortOrder: '/umbraco/api/generalcontentsearchapi/sortorders'  
}


